import React, { useState } from "react";
import {
  TextField,
  Button,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import styles from "./ContactDetails.module.css";
import Logo from "../components/Logo";
import SideBackground from "../components/SideBackground";
import api from "../API/axios";
import NotificationSnackbar from "../components/NotificationSnackbar";
import useNotification from "../hooks/useNotification";

export default function TwoFactorMethod() {
  const { notification, showNotification, hideNotification } =
    useNotification();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    method: "",
    email: "",
  });
  const [errors, setErrors] = useState({
    method: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    // Clear errors when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }

    // Auto-populate email when email method is selected
    if (name === "method" && value === "email") {
      // Get email from URL params or localStorage if available
      const params = new URLSearchParams(window.location.search);
      const email =
        params.get("email") || localStorage.getItem("userEmail") || "";
      setForm({ ...form, method: value, email: email });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset errors
    setErrors({ method: "", email: "" });

    // Validate method selection
    if (!form.method) {
      setErrors({
        ...errors,
        method: "Please select a 2-factor authentication method",
      });
      return;
    }

    // Validate email if email method is selected
    // if (form.method === "email" && !form.email) {
    //   setErrors({ ...errors, email: "Email address is required" });
    //   return;
    // }

    // Get verification token from URL
    const params = new URLSearchParams(window.location.search);
    const verificationToken = params.get("token");
    if (!verificationToken) {
      showNotification("Verification token missing.", "error");
      return;
    }

    try {
      if (form.method === "email") {
        setLoading(true);
        // Send 2FA code via email
        const response = await api.post("/TwoFactor/setup-email", {
          token: verificationToken,
        });
        showNotification("2FA code sent to your email!", "success");
        // Redirect to email verification page
        setLoading(false);
        if (response.status === 200) {
          // Email sent successfully
          window.location.href = `/two-factor-verify?token=${verificationToken}&method=email`;
        } else {
          setTimeout(() => {
            window.location.href = `/two-factor-verify?token=${verificationToken}&method=email`;
          }, 2000);
        }
      } else if (form.method === "app") {
        // Setup 2FA app
        // Redirect to app setup page
        window.location.href = `/two-factor-app?token=${verificationToken}`;
      }
    } catch (err) {
      console.error(err);
      showNotification(
        "Failed to setup 2-factor authentication. Please try again.",
        "error"
      );
    }
  };

  return (
    <div className={styles.contactDetailsRoot}>
      <div className={styles.contactDetailsLeft}>
        <div className={styles.contactDetailsLogoWrap}>
          <Logo />
        </div>
        <form className={styles.contactDetailsForm} onSubmit={handleSubmit}>
          <h2>Complete Setup</h2>
          <h4
            style={{
              textAlign: "center",
              fontWeight: 600,
              margin: "0px",
              marginTop: "-10px",
              color: "#888",
            }}
          >
            2 Factor Method
          </h4>
          <div
            style={{
              fontSize: "13px",
              width: "100%",
              textAlign: "center",
              marginBottom: 12,
              color: "#666",
            }}
          >
            <p>
              To help keep your account secure, please select your preferred
              method of
              <br />
              two factor authentication (2FA).
            </p>
          </div>
          <div
            style={{
              width: "100%",
              maxWidth: 260,
              display: "flex",
              flexDirection: "column",
              margin: "0 auto",
            }}
          >
            <TextField
              select
              label="2 Factor Method"
              name="method"
              value={form.method}
              onChange={handleChange}
              fullWidth
              required
              sx={{
                width: "100%",
                maxWidth: 260,
                marginBottom: 1,
              }}
            >
              <MenuItem value="email">Email</MenuItem>
              <MenuItem value="app">Authenticator App</MenuItem>
            </TextField>

            {/* Email Field - only show when email method is selected */}
            {/* 
            {form.method === "email" && (
              <TextField
                type="email"
                label="Email Address"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                error={!!errors.email}
                inputProps={{ maxlength: 255 }}
                sx={{ mt: 2 }}
              />
            )} */}

            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={loading}
              sx={{
                mt: 2,
                width: "100%",
                backgroundColor: "var(--color-primary)",
                "&:hover": { backgroundColor: "var(--color-secondary)" },
              }}
            >
              {loading ? "Loading..." : "Continue"}
            </Button>
          </div>

          {/* Method selection error */}
          {/* {errors.method && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errors.method}
            </Alert>
          )} */}
          {/* Email error */}
          {/* {errors.email && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errors.email}
            </Alert>
          )} */}
        </form>
      </div>
      <SideBackground>
        <div className={styles.contactDetailsBgOverlay}></div>
      </SideBackground>

      {/* Notification Snackbar */}
      <NotificationSnackbar
        open={notification.open}
        message={notification.message}
        severity={notification.severity}
        onClose={hideNotification}
      />
    </div>
  );
}
